import { Form } from "../Form/Form";
import "../../styles/PopUpForm.scss";

export function PopUpForm({ onClose, title, dbPath }) {
  return (
    <div className="popupBox-container visible">
      <div className="close-button" onClick={onClose}>
        X
      </div>
      <div className="popup-content">
        <h2>{title || "Data Deletion Request"}</h2>
        <Form dbPath={dbPath} />
      </div>
    </div>
  );
}
